document.addEventListener('DOMContentLoaded',function(){
  if(!document.body.classList.contains('template-product')) return;

  document.querySelectorAll('.engraving-box textarea, textarea[name*="Gravi"], textarea[name*="gravi"]').forEach(function(el){
    el.removeAttribute('required');
    el.removeAttribute('aria-required');
    el.value='';
  });

  document.querySelectorAll('.engraving-box').forEach(function(el){
    el.remove();
  });

  document.querySelectorAll('.purchase-panel__head p').forEach(function(el){
    el.textContent='Pridėkite sveikinimo kortelę su tekstu – ją paruošime estetiškai ir įdėsime prie dovanos.';
    el.setAttribute('data-cleaned-engraving','true');
  });

  document.querySelectorAll('.p-desc').forEach(function(el){
    el.innerHTML=el.innerHTML
      .replace(/su asmenine graviūra\s*[—-]\s*vardas, data ar trumpa žinutė\.?/gi,'')
      .replace(/su graviūra/gi,'')
      .replace(/graviūros tekstą arba /gi,'')
      .replace(/graviūros tekstą/gi,'sveikinimo tekstą')
      .replace(/graviūra ar /gi,'')
      .replace(/, graviūra/gi,'');
  });
});
